<script>
export default {
  props: ['code'],
  data() {
    return {
      listHoanThanh : [],
      listDangXuLy : [],
      listTreHan : [],
      listKhoKhan : [],
      listNam : [],
      chartDataEachYear: {
        series: [

        ],
        chartOptions: {
          xaxis: {
            categories : [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025",
            ],
          },
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: false,
            },
          },
          colors: ["#449d73",'#ffc35e',"#e85b5b", "#ec6868"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          markers: {
            size: 3,
            strokeWidth: 3,
            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      selection: "all",
    };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
    this.getAll();

  },
  mounted() {
  },
  methods: {
    async getAll() {
      await this.$store.dispatch("statisticalStore/getTungNam").then((res) => {
        if (res.code === 0) {
          this.chartDataEachYear.series = [];
          this.chartDataEachYear.chartOptions.xaxis.categories = [];
          this.chartDataEachYear.series = res.data.listData;
        //  this.chartDataEachYear.chartOptions.xaxis.categories = res.data.listYear
          // res.data.listYear.forEach(elements => this.chartDataEachYear.chartOptions.xaxis.categories.push(elements + 1));

          console.log("LOG DATA : ",this.chartDataEachYear.chartOptions.xaxis.categories )

        }
      })
    },
  }
};
</script>

<template>
  <div class="card-body">
      <div class="row">
        <h4 class="text-center font-weight-bold text-dark">
          BIỂU ĐỒ SỐ LƯỢNG CÂU HỎI THEO TỪNG NĂM
        </h4>
      </div>
    <hr class="mb-1" style="margin-top: 1px" />
    <apexchart
        class="apex-charts"
        dir="ltr"
        type="area"
        height="370"
        :series="chartDataEachYear.series"
        :options="chartDataEachYear.chartOptions"
    ></apexchart>
  </div>
</template>
